"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CreateWorker = /*#__PURE__*/_createClass(function CreateWorker(worker) {
  _classCallCheck(this, CreateWorker);

  ;
  var code = worker.toString();
  code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
  code = new Blob([code], {
    type: 'application/javascript'
  });
  code = new Worker(URL.createObjectURL(code));
  return code;
});

exports["default"] = CreateWorker;